/**
 * @generated SignedSource<<43a4e242a299af0069c90bc66d532de1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveGridRuleMutation$variables = {
  gridRuleId: string;
  productIds?: ReadonlyArray<number> | null;
};
export type productSidePanelContent_RemoveGridRuleMutation$data = {
  readonly removeProductsFromGridRule: {
    readonly result: string | null;
  } | null;
};
export type productSidePanelContent_RemoveGridRuleMutation = {
  response: productSidePanelContent_RemoveGridRuleMutation$data;
  variables: productSidePanelContent_RemoveGridRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "gridRuleId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "gridRuleId",
        "variableName": "gridRuleId"
      },
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      }
    ],
    "concreteType": "GridRuleResponse",
    "kind": "LinkedField",
    "name": "removeProductsFromGridRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveGridRuleMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveGridRuleMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "fa52f4ad4ba60e799291bf844179a7c4",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveGridRuleMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveGridRuleMutation(\n  $gridRuleId: ID!\n  $productIds: [Long!]\n) {\n  removeProductsFromGridRule(gridRuleId: $gridRuleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "11b220f7412bfba6be8b6aa6b5f61f0a";

export default node;
